import * as React from 'react';
import { EllipsisIcon } from 'lucide-react';
import { eventBus } from 'services/eventBus';
import { usePermission } from 'hooks/usePermission';
import type { Equipment } from 'contracts/temperature-control/equipments';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';

type Props = {
  equipment: Equipment
}

export const EquipmentActionsMenu = ({ equipment }: Props) => {
  const { hasPermissionTo } = usePermission();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger onClick={(event) => {
        event.stopPropagation();
      }}>
        <EllipsisIcon className={'text-gray-600'} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align={'end'}>
        <DropdownMenuItem
          disabled={!hasPermissionTo(['TEMPERATURE_CONTROL.EQUIPMENT.DELETE'])}
          onClick={(e) => {
            eventBus.dispatch('show-delete-equipment-confirmation-dialog', equipment);
            e.stopPropagation();
          }}
        >
          Remover equipamento
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};